import React, { useCallback, useContext, useState } from 'react'
import OfferFilterSelectBox from '../OfferFilterSelectBox'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import LineNightIcon from 'components/Luxkit/Icons/line/LineNightIcon'
import { pluralizeToString } from 'lib/string/pluralize'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import OfferPageStateTrackingContext from 'contexts/OfferPage/offerPageStateTrackingContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import noop from 'lib/function/noop'
import useMountedEffect from 'hooks/useMountedEffect'

interface Props {
  duration: number;
  inSidebar?: boolean;
  open?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  iconDisabled?: boolean;
}

const OfferDurationSelectBox = React.forwardRef<HTMLButtonElement | HTMLDivElement, Props>((props, ref) => {
  const { duration, open, onClick = noop, inSidebar, iconDisabled } = props
  // Show a placeholder until we see the user actually select something or they interact with filter
  const [showPlaceholder, setShowPlaceholder] = useState<boolean>(true)

  useMountedEffect(() => {
    setShowPlaceholder(false)
  }, [duration, open])

  const dispatch = useOfferPageDispatch()
  const { trackEvent } = useContext(OfferPageStateTrackingContext)
  const onBoxClick = useCallback<React.MouseEventHandler<HTMLButtonElement>>((e) => {
    if (open) {
      dispatch({ type: OfferPageActions.closeFilter })
      trackEvent('DURATION_FILTER_CLOSED')
    } else {
      trackEvent('DURATION_FILTER_PRESSED')
      dispatch({ type: OfferPageActions.toggleFilter, filter: 'duration' })
    }
    onClick(e)
  }, [dispatch, onClick, open, trackEvent])

  return <OfferFilterSelectBox
    inSidebar={inSidebar}
    ref={ref}
    onClick={onBoxClick}
    icon={!iconDisabled && <LineNightIcon />}
    active={open}
    data-testid="OfferDurationSelectBox"
    label="Duration"
    placeholder="Select"
    value={(showPlaceholder && !inSidebar) ? undefined : <b>{pluralizeToString('night', duration) }</b>}
  />
})

OfferDurationSelectBox.displayName = 'OfferDurationSelectBox'

export default withOfferPageState(state => ({
  duration: state.duration,
  open: state.activeFilter === 'duration',
}), true)(OfferDurationSelectBox)
